// extracted by mini-css-extract-plugin
export default {"emergencyButton":"EmergencyButton_emergencyButton__IXfBi","emergencyInfo":"EmergencyButton_emergencyInfo__9cOx0","active":"EmergencyButton_active__yQW3L"};